import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

var ResetDone =
/*#__PURE__*/
function (_Vue) {
  _inherits(ResetDone, _Vue);

  function ResetDone() {
    _classCallCheck(this, ResetDone);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResetDone).apply(this, arguments));
  }

  _createClass(ResetDone, [{
    key: "clickReset",
    value: function clickReset() {}
  }, {
    key: "clickDone",
    value: function clickDone() {}
  }]);

  return ResetDone;
}(Vue);

tslib_1.__decorate([Prop({
  default: false
})], ResetDone.prototype, "redColor", void 0);

tslib_1.__decorate([Emit("clickReset")], ResetDone.prototype, "clickReset", null);

tslib_1.__decorate([Emit("clickDone")], ResetDone.prototype, "clickDone", null);

ResetDone = tslib_1.__decorate([Component({
  components: {}
})], ResetDone);
export default ResetDone;